var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import { clone, } from "../utilities/aux";
import { isArray, isNumber, } from "../utilities/wsi4_typeguards";
function toSvg(s) {
    const dp = new DOMParser();
    return dp.parseFromString(s, "image/svg+xml").documentElement;
}
function mergeSvgs(svgs) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (svgs.length === 0) {
        return svg;
    }
    {
        const viewBox = svgs[0].element.viewBox.baseVal;
        svg.setAttribute("viewBox", String(viewBox.x) + " " + viewBox.y.toString() + " " + viewBox.width.toString() + " " + viewBox.height.toString());
    }
    for (const e of svgs) {
        const elem = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        const paths = e.element.querySelectorAll("path");
        for (const p of paths) {
            if (e.hovered) {
                const tmp = (p.cloneNode(true));
                tmp.setAttribute("stroke", "limegreen");
                const strokeWidth = p.getAttribute("stroke-width");
                if (strokeWidth === null) {
                    throw Error("Stroke width missing");
                }
                const w = Number.parseInt(strokeWidth);
                tmp.setAttribute("stroke-width", (3 * w).toString());
                elem.appendChild(tmp);
            }
            elem.appendChild(p);
        }
        svg.appendChild(elem);
    }
    return svg;
}
var State;
(function (State) {
    State["cutting"] = "cutting";
    State["engraving"] = "engraving";
    State["none"] = "none";
    State["disabled"] = "disabled";
})(State || (State = {}));
function isState(arg) {
    return arg === State.cutting || arg === State.engraving || arg === State.none || arg === State.disabled;
}
let LayeredView = class LayeredView extends Vue {
    constructor() {
        super(...arguments);
        this.currentStates = [];
        this.thickness = 1;
        this.hoveredDescriptor = -1;
    }
    twoDimInputChanged() {
        return this.twoDimInput();
    }
    updateDialog() {
        this.updateSvg();
        this.twoDimInputChanged();
    }
    updateSvg() {
        const s = this.$el.querySelector(".layered-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.layered-svg' does not match");
        }
        if (s.contains(this.currentSvg)) {
            s.removeChild(this.currentSvg);
        }
        this.currentSvg = mergeSvgs(this.descriptorStates
            .filter(e => e.state !== State.none && e.state !== State.disabled)
            .map(e => ({
            element: toSvg(this.invalidLayered.layerViewDatas[e.descriptor].svg),
            hovered: e.descriptor === this.hoveredDescriptor,
        })));
        s.appendChild(this.currentSvg);
    }
    hoverDescriptor(descriptor) {
        this.hoveredDescriptor = descriptor;
        this.updateSvg();
    }
    isCutting(descriptor) {
        return this.currentStates[descriptor] === State.cutting;
    }
    isEngraving(descriptor) {
        return this.currentStates[descriptor] === State.engraving;
    }
    isNotSelected(descriptor) {
        return this.currentStates[descriptor] === State.none;
    }
    isDisabled(descriptor) {
        return this.currentStates[descriptor] === State.disabled;
    }
    changeState(descriptor, state) {
        const tmp = this.currentStates;
        tmp[descriptor] = state;
        this.currentStates = clone(tmp, (arg) => isArray(arg, isState));
        this.updateDialog();
        this.twoDimInputChanged();
    }
    twoDimInput() {
        return {
            layered: this.invalidLayered.layered,
            cuttingLds: this.descriptorStates.filter(s => s.state === State.cutting)
                .map(s => s.descriptor),
            engravingLds: this.descriptorStates.filter(s => s.state === State.engraving)
                .map(s => s.descriptor),
            thickness: this.thickness,
            importId: this.invalidLayered.importId,
            name: this.invalidLayered.name,
        };
    }
    toSvgColor(e) {
        if (e === undefined) {
            return "none";
        }
        const map = {
            black: "black",
            red: "red",
            white: "white",
            blue: "blue",
            green: "green",
            lime: "lime",
            saddlebrown: "saddlebrown",
            cyan: "cyan",
            turquoise: "turquoise",
            yellow: "yellow",
            magenta: "magenta",
            none: "none",
            sienna: "sienna",
            lightgrey: "lightgrey",
            violet: "violet",
            darkorange: "darkorange",
            closedContour: "black",
            openContour: "black",
            closedOuterContour: "black",
            closedInnerContour: "black",
            engraving: "yellow",
            bendLine: "green",
            bendLineUp: "green",
            bendLineDown: "green",
        };
        return map[e];
    }
    get descriptorStates() {
        return this.currentStates.map((s, index) => ({ state: s, descriptor: index }));
    }
    get thicknessInvalid() {
        return !isNumber(this.thickness) || this.thickness <= 0;
    }
    get engravingEnabled() {
        return this.networkBroker.configuration.engravingSelection;
    }
    mounted() {
        this.currentStates = this.invalidLayered.layerViewDatas.map(l => {
            if (l.svg.length === 0) {
                return State.disabled;
            }
            if (this.defaultResult === undefined) {
                if (this.invalidLayered.cuttingLds.length === 0 && this.invalidLayered.engravingLds.length === 0) {
                    return State.cutting;
                }
                if (this.invalidLayered.cuttingLds.some(c => c === l.descriptor)) {
                    return State.cutting;
                }
                else if (this.invalidLayered.engravingLds.some(c => c === l.descriptor)) {
                    return State.engraving;
                }
                return State.none;
            }
            else if (this.defaultResult.cuttingLds.some(c => c === l.descriptor)) {
                return State.cutting;
            }
            else if (this.defaultResult.engravingLds.some(c => c === l.descriptor)) {
                return State.engraving;
            }
            else {
                return State.none;
            }
        });
        this.updateDialog();
    }
    onThicknessChanged() {
        this.twoDimInputChanged();
    }
};
__decorate([
    Prop({ required: true })
], LayeredView.prototype, "invalidLayered", void 0);
__decorate([
    Prop({ required: true })
], LayeredView.prototype, "defaultResult", void 0);
__decorate([
    Inject()
], LayeredView.prototype, "i18n", void 0);
__decorate([
    Inject()
], LayeredView.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], LayeredView.prototype, "twoDimInputChanged", null);
__decorate([
    Watch("thickness")
], LayeredView.prototype, "onThicknessChanged", null);
LayeredView = __decorate([
    Component({
        components: {},
        name: "LayeredView",
    })
], LayeredView);
export default LayeredView;
